const ConditionalRender = ({ if: condition, children }) => {
  return condition ? children : null;
}

export default ConditionalRender;
